import Button from 'Components/Atoms/Button/Button';
import Checkbox from 'Components/Atoms/Checkbox/Checkbox';
import Container from 'Components/Atoms/Container/Container';
import Title from 'Components/Atoms/Title/Title';
import ButtonGroup from 'Components/Molecules/ButtonGroup/ButtonGroup';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Modal from 'Components/Molecules/Modals/Modal/Modal';
import ModalFooter from 'Components/Molecules/Modals/ModalFooter/ModalFooter';
import ModalHeader from 'Components/Molecules/Modals/ModalHeader/ModalHeader';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import Field from 'Components/Organisms/Field/Field';
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getInternalDatasetIdByName } from 'Services/helpers';
import useApi from 'Services/Api/useApi';
import ContactModuleHelper from 'Services/Settings/Modules/ContactModule/ContactModuleHelper';
import { MODULES } from 'Services/Settings/Modules/Helper';
import Validator from 'Services/Utils/Validator/Validator';
import { FieldType } from 'Store/FieldManagement/PropTypes';
import { createContactModule, patchContactModules } from 'Store/Modules/ContactModule/Actions';
import { getContactByEntityId, getContactByIdAsObject, isContactCreating, isContactModulePatching } from 'Store/Modules/ContactModule/Selectors';
import { StoreState } from 'Store/Reducers';
import { getEntitiesById, getEntityById } from 'Store/Settings/Entities/Selectors';
import { getModulesByEntityIdByModule } from 'Store/Settings/Modules/Selectors';

const ContactEdit = ({
    id, record_id, entity_id, onClose,

    contact_method, contact_methods,
    modulesByEntityIdByModule,
    entityById, entity,

    isContactModulePatching,

    ...props
}: ContactEditProps) => {
    const { fetch } = useApi();

    const [types, setTypes] = useState([]);
    const initialState = {
        type: '',
        is_primary: false,
        value: '',
        relation: [],
        label: []
    }
    const [data, setData] = useState<any>(contact_method?.[id] ?? {});
    const [state, setState] = useState({
        isValid: false,
        isPrimary: false,
    });

    const handleChange = (key: string) => (value: any) => {
        if (key === 'type' && !value) return setData(initialState);
        if (key === 'type' && value) {
            const primaryContactMethods = contact_methods?.filter(i => i?.type === value);
            const isPrimary = !primaryContactMethods || primaryContactMethods?.length === 0 || value === 'linkedin';
            setState((state) => ({
                ...state,
                isPrimary: isPrimary 
            }));
            setData((data) => ({
                ...data,
                is_primary: isPrimary
            }));
        }

        setData((data) => ({
            ...data,
            [key]: value
        }));
    }

    const handleEdit = () => {
        if (contact_methods && !!data.is_primary) {
            const contactMethods = contact_methods?.filter(i => i?.type === data.type && i?.is_primary);
            
            for (const item of contactMethods) {
                props.patchContactModules(item.id, {
                    is_primary: false
                });
            }
        }

        props.patchContactModules(id, data);
    };

    const fetchTypes = async () => {
        const rawResponse = await fetch(`/api/v2/contact_module/${entity.name}/types`);
        let response  = rawResponse.map(i => ({
            label: ContactModuleHelper.getTypeLabelByValue(i),
            value: i
        }));
        
        const hasLinkedIn = contact_methods?.filter(i => i.type === 'linkedin')?.length > 0;
        if (hasLinkedIn) {
            response = response?.filter(i => i.type !== 'linkedin')
        }

        setTypes(response);
    }

    useEffect(() => {
        fetchTypes();
    }, []);

    useEffect(() => {
        if (!isContactModulePatching && state.isValid) onClose();
    }, [isContactModulePatching]);

    useEffect(() => {
        let isValid = true;
        if (!data?.type) isValid = false;

        const hasRelation = entity.name === 'contact';
        const hasLabel = entity.name === 'business_unit';
        if (hasRelation && data.relation?.length === 0) isValid = false;
        if (hasLabel && data.label?.length === 0) isValid = false;
        if (data.type === 'email' && !Validator.isEmailaddressValid(data.value)) isValid = false;
        if (data.type === 'phone' && !Validator.isPhonenumberValid(data.value)) isValid = false;
        if (data.type === 'linkedin' && !Validator.isValidUrl(data.value)) isValid = false;

        setState((state) => ({
            ...state,
            isValid
        }));
    }, [data]);

    return <Modal size='small'>
        <ModalHeader size='small'>
            <TitleGroup>
                <Title
                    size='medium'
                    weight='bold'
                    transform="uppercase"
                >
                    Contactgegeven aanpassen
                </Title>
            </TitleGroup>
        </ModalHeader>

        <Container padding='vertical'>
            <FormGroup
                title='Type'
                isRequired
            >
                <Field
                    isEdit={true}
                    value={data?.type}
                    onChange={handleChange('type')}
                    type={FieldType.Select}
                    properties={{
                        list: types,
                        isDisabled: true
                    }}
                />
            </FormGroup>
            {
                data?.type &&
                <FormGroup title='Is primair?'>
                    <Checkbox
                        state={
                            data.is_primary || state.isPrimary
                            ? 'active'
                            : 'inactive'
                        }
                        onClick={() => setData((data) => ({
                            ...data,
                            'is_primary': !data.is_primary
                        }))}
                        label=''
                    />
                </FormGroup>
            }

            {
                data?.type
                && entity?.name === 'contact'
                && <FormGroup
                    title='Relatie'
                    isRequired
                >
                    <Field
                        isEdit={true}
                        value={data.relation}
                        onChange={handleChange('relation')}
                        type={FieldType.Multi_Selector}
                        properties={{
                            dataset: [getInternalDatasetIdByName(entityById?.[modulesByEntityIdByModule?.[entity_id]?.[MODULES.CONTACT]?.configuration?.[data.type]?.relation]?.name)],
                            inRelation: [record_id]
                        }}
                    />
                </FormGroup>
            }
            {
                data?.type &&
                <FormGroup
                    isRequired
                    title={ContactModuleHelper.getTypeLabelByValue(data.type)}
                >
                    <Field
                        isEdit={true}
                        value={data.value}
                        onChange={handleChange('value')}
                        type={FieldType.Text}
                    />
                </FormGroup>
            }
            {
                data?.type &&
                entity.name === 'business_unit'
                && <FormGroup title='Afdeling'>
                    <Field
                        isEdit={true}
                        value={data?.label ?? []}
                        onChange={handleChange('label')}
                        type={FieldType.MultiSelect}
                        properties={{
                            list: modulesByEntityIdByModule
                                ?.[entity_id]
                                ?.[MODULES.CONTACT]
                                ?.configuration
                                ?.labels
                                ?.map(i => ({
                                    label: i.name,
                                    value: i.id
                                }))
                        }}
                    />
                </FormGroup>
            }
        </Container>

        <ModalFooter size='small'>
            <ButtonGroup>
                {
                    !isContactModulePatching
                    && <Button
                        variant="transparent"
                        onClick={onClose}
                    >
                        Annuleren
                    </Button>
                }
                <Button
                    color="primary"
                    variant="solid"
                    onClick={handleEdit}
                    isDisabled={!state.isValid}
                    isLoading={isContactModulePatching}
                >
                    Opslaan
                </Button>
            </ButtonGroup>
        </ModalFooter>
    </Modal>
}

interface Props {
    id: string
    record_id: string
    entity_id: string
    onClose: any
};

const mapState = (state: StoreState, props: Props) => ({
    modulesByEntityIdByModule: getModulesByEntityIdByModule(state),
    entityById: getEntitiesById(state),
    entity: getEntityById(state, props.entity_id),

    contact_method: getContactByIdAsObject(state),
    contact_methods: getContactByEntityId(state, props.record_id),

    isContactModulePatching: isContactModulePatching(state)
});

const mapDispatch = {
    createContactModule,
    patchContactModules
};

type ContactEditProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(ContactEdit);